export class ApiError extends Error {
    constructor(clazz: string, message?: string, error?: Error) {
        super(`[${clazz}] ${message || ''} ${error?.message || ''}`);
        this.stack = error?.stack;
        Object.setPrototypeOf(this, ApiError.prototype);
    }
}